module.exports = __webpack_public_path__ + "static/img/echarts-bg.b6371ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/echarts-bg.png
// module id = UsY3
// module chunks = 1